import { Edit, SimpleForm, TextInput } from 'react-admin';

const PasswordEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="web" label="Web/App" />
            <TextInput source="pass" label="Password"  />
        </SimpleForm>
    </Edit>
);

export default PasswordEdit;
